<script>
    import Layout from "../../layouts/main";
    import appConfig from "@/app.config";
    import apigeneric from "@/helpers/apigeneric";
    import Loader from "@/components/widgets/loader";
    import Banner from "../components/banner";
    import apibtoast from "@/helpers/apibtoast";
    
    export default {
      page: {
        title: "Web Siteleri",
        meta: [
          {
            name: "description",
            content: appConfig.description,
          },
        ],
      },
      components: {
        Layout,
        Loader,
        Banner
    
      },
      mixins: [apigeneric, apibtoast],
      data() {
        return {
          DefaultPage: 1,
          Page: {
            PageNumber: "1",
            PageSize: "10",
            PageDataSize: "1",
          },
          VeritabaniData: {},
          VeritabaniId: this.$route.params.VeritabaniId,
          LangId: this.$route.params.LangId,
          Title: this.$route.params.Title
          
          
        };
      },
      methods: {
        Get() {

          if(this.LangId=="tr" || this.LangId== null){
      this.ActionsSingleGet({
        Service: "veritabanlari",
        Id: this.VeritabaniId,
      }).then((res) => {
        this.VeritabaniData = res.Data;
        
      });
    }else{
      this.ActionsFilterGet({
        Service: "languages",
        Page: this.Page,
        Filter:
       "&shortlangtitle="+this.LangId
      }).then((res) => {
        for(let LangData in res.Data){
          this.ActionsFilterGet({
          Service: "veritabanlaritranslations",
          Page: this.Page,
          Filter: "&Langid="+ res.Data[LangData].Id + "&Veritabaniid=" + this.VeritabaniId
        }).then((res) => {
          this.VeritabaniData = res.Data[0];
          if(res.TotalCount == 0){
              localStorage.setItem("lang", "tr");
              window.location.reload();
              
            }
        
      });
        }
      });

      
    }
        
          }
      },
    };
    </script>
        
    <template>
      <Loader>
        <Layout>
          <Banner />
          <div class="title c-flex flex-column mt-3 col-md-8 mx-auto" style="background-color: #0071c5; height: 50px; padding: 10px; box-shadow: 5px 7px 5px #888888; border-radius: 10px;">
            <p class="h2 text-center" style="color: white">{{ $t("veritabanlari.Title") }}</p>
            </div>
          <div class="news-detail">
            <div class="title c-flex flex-column mb-2">
              <h5>{{VeritabaniData.Title}}</h5>
            </div>
            <div class="container">
              <div class="row">
                <div class="col-md-10 mx-auto">
                  <div class="news">
                    <div class="image">
                      <img :src="$config.FILES_URL + 'web/' + VeritabaniData.Imageurl" alt="">
                    </div>
                    <div class="new-header justify-content-end">
                      <div class="new-date" style="background-color: #B0C4DE; border-radius: 5px;">
                        <span class="date">{{VeritabaniData.Createddate | formatDateTime}}</span>
                      </div>
                    </div>
                    <div class="new-content">
                      <span v-html="VeritabaniData.Description"></span><br />
                    </div>
    
                  </div>
                </div>
    
              </div>
            </div>
          </div>
        </Layout>
      </Loader>
    </template>
        